/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.body;

let isMobile = false; // Ensure it's always defined

const updateBodyClass = () => {
  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
  const isiPad = navigator.userAgent.includes("Mac") && isTouchDevice;

  // Update global `isMobile` variable
  isMobile =
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || isiPad || isTouchDevice;

  if (isMobile) {
    body.classList.add("is-mobile");
  } else {
    body.classList.remove("is-mobile");
  }
};

// Run on load and on resize
updateBodyClass();
window.addEventListener("resize", updateBodyClass);

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

// Update viewport height for mobile
const setViewHeight = () => {
  document.documentElement.style.setProperty("--vh", isMobile ? "100dvh" : `${window.innerHeight}px`);
};

setViewHeight();
window.addEventListener("load", setViewHeight);
window.addEventListener("resize", setViewHeight);

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - service accordion
    ========================================================================== */

const accordionServices = document.querySelectorAll(".accordion__service");

const serviceInit = function (serviceItems) {
  if (!serviceItems) {
    return;
  }

  serviceItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".service__item").classList.toggle("service__item--open");
    })
  );
}; // serviceInit();
serviceInit(accordionServices);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Fancybox updates popup gallery
    ========================================================================== */

$("[data-fancybox]").fancybox({
  touch: false,
  buttons: ["close"],
  thumbs: {
    autoStart: true, // Display thumbnails on opening
    axis: "x" // Vertical (y) or horizontal (x) scrolling
  },
  btnTpl: {
    smallBtn:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      "<svg width='18' height='14' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'><line x1='1.16117' y1='0.454064' x2='19.5459' y2='18.8388' stroke='#FFFFFF'/><line x1='0.454064' y1='18.8388' x2='18.8388' y2='0.454055' stroke='#FFFFFF'/></svg>" +
      "</button>",
    close:
      "<button data-fancybox-close class='fancybox-button fancybox-button--close' title='{{CLOSE}}'>" +
      "<svg width='18' height='14' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'><line x1='1.16117' y1='0.454064' x2='19.5459' y2='18.8388' stroke='#FFFFFF'/><line x1='0.454064' y1='18.8388' x2='18.8388' y2='0.454055' stroke='#FFFFFF'/></svg>" +
      "</button>",
    arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<div><i class="fal text-large fa-chevron-left"></i></div>' +
      "</button>",
    arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<div><i class="fal text-large fa-chevron-right"></i></div>' +
      "</button>"
  },
  afterShow: function () {
    // cursorsInit();
  },
  afterClose: function () {
    playPageHeaderHomeVideo();
  }
});

/*  ==========================================================================
    GENERAL - Play page header home video to be called when the fancybox is closed
    ========================================================================== */

function playPageHeaderHomeVideo() {
  const pageHeaderHomeVideoiframe = document.querySelector(
    ".pageheader--home .pageheader__bg .pageheadervideo .pageheadervideo__iframe--vimeo"
  );

  if (!pageHeaderHomeVideoiframe) {
    return;
  }

  const player = new Vimeo.Player(pageHeaderHomeVideoiframe);

  player.play();
}

/*  ==========================================================================
    GENERAL - Favicon animation 
    ========================================================================== */

var favicon_images = [
    "/wp-content/themes/1HQ/img/framework/1hq-1.png",
    "/wp-content/themes/1HQ/img/framework/1hq-2.png",
    "/wp-content/themes/1HQ/img/framework/1hq-3.png"
  ],
  favicon_image_counter = 0; // To keep track of the current image

setInterval(function () {
  var favicon = document.querySelector("link[rel='icon']");
  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    favicon.type = "image/gif";
    document.head.appendChild(favicon);
  }

  favicon.href = favicon_images[favicon_image_counter];

  // If last image then go to first image, otherwise go to the next image
  favicon_image_counter = (favicon_image_counter + 1) % favicon_images.length;
}, 666);

/*  ==========================================================================
      Enable Iframe resizer for Pardot forms
      - For this to work the script also needs to be called within the iframe (e.g. in pardot)
      - the tutorial for this is here: https://jennamolby.com/how-to-embed-a-pardot-form-on-your-website-the-right-way/
      ========================================================================== */

var formIframes = document.querySelectorAll(".pardot-iframe");

if (formIframes.length) {
  formIframes.forEach(function (formIframe) {
    iFrameResize({}, formIframe);
  });
}

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    let plyrRatio = plyr.dataset.ratio;
    let plyrOptions = {
      controls: ["play", "progress", "current-time", "mute", "volume"],
      hideControls: true,
      invertTime: false,
      autoplay: false,
      ratio: plyrRatio,
      autopause: false,
      fullscreen: { enabled: false },
      tooltips: { controls: false, seek: false }
    };
    if (el.classList.contains("mediavideo--autoplay-controls")) {
      // autoplay with controls
      plyrOptions.controls = ["play", "mute", "volume"];
      plyrOptions.autoplay = true;
      plyrOptions.volume = 0;
      plyrOptions.muted = true;
      plyrOptions.loop = { active: true };
    }
    new Plyr(plyr, plyrOptions);
  });
}; // plyrsInit();

plyrsInit();

// /*  ==========================================================================
//   GENERAL - Initiate plyr (custom video controls)
// ========================================================================== */

// const pageHeaderHomeBackgroundVideo = document.querySelector(
//   ".pageheader--home .pageheader__bg .pageheadervideo .pageheadervideo__iframe--vimeo"
// );

// const pageHeaderHomeVideoInit = function () {
//   // Ensure the video exists
//   if (!pageHeaderHomeBackgroundVideo) {
//     return;
//   }

//   console.log("LOADED");

//   $("[data-fancybox]").fancybox({
//     afterClose: function (instance, slide) {
//       console.log("CLOSED");
//       if (pageHeaderHomeBackgroundVideo.paused) {
//         console.log("PAUSED");
//       } else {
//         console.log("ALREADY PLAYING");
//       }
//     }
//   });
// };

// pageHeaderHomeVideoInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;

  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.remove();
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
        //cursorsInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    FILTERING - URL Parameter functions
    ========================================================================== */

/* UPDATE URL PARAMETERS */
function filters__update_url(filter_data) {
  var url_params = "";

  $.each(filter_data, function (key, value) {
    if (!$.isEmptyObject(value)) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  });

  var page_url = window.location.href.split("?")[0];
  var new_url = page_url + url_params;

  if (history.pushState) {
    window.history.pushState({ path: new_url }, "", new_url);
  }
}

/*  ==========================================================================
			FILTERING - Filter posts
			========================================================================== */

// Get current filters data from form inputs
function filters__get_filter_data(form, filters) {
  let filter_data = {};
  $(filters).each(function () {
    filter_data[this.name] = {};
    $("input[type=checkbox][name=" + this.name + "]:checked").each(function (index) {
      filter_data[this.name][index] = $(this).val();
    });
  });
  return filter_data;
}

// Setup styling classes on new filter
function filters__update_styling(filter_data) {
  // Reset styles
  $(".filters__fieldset").removeClass("filters__fieldset--active");
  $(".filters__fieldset__field").removeClass("filters__fieldset__field--active");

  // Reset tags
  $(".filters__tags").removeClass("filters__tags--active");

  $.each(filter_data, function (key, values) {
    if (!$.isEmptyObject(values)) {
      let filter_name = key;
      // Make field group active
      $(".filters__fieldset[data-value='" + key + "']").addClass("filters__fieldset--active");
      $.each(values, function (key, value) {
        // Make input field active
        let filter_input = $("input[name='" + filter_name + "'][value='" + value + "']").closest(
          ".filters__fieldset__field"
        );
        $(filter_input).addClass("filters__fieldset__field--active");
        // Show active tags
        $(".filters__tags").addClass("filters__tags--active");
      });
    }
  });

  if ($(".filters__tags").hasClass("filters__tags--active")) {
    // Remove active class on "all work"
    $(".filters__clearall").removeClass("filters__clearall--active");
  } else {
    // add active class on "all work"
    $(".filters__clearall").addClass("filters__clearall--active");
  }
}

function filters__filter_posts() {
  // Get filters and search passed in to main.js via filters.php
  let filters = filter_settings.filters;

  let filter_data = filters__get_filter_data($(".filters"), filters);

  if (filter_data) {
    // Update filter styling and tags
    filters__update_styling(filter_data);

    // Update url
    filters__update_url(filter_data);

    // If is initial load and there is active tags on search data then trigger ajax, if not initial load then trigger everytime
    if ((filters_initial_load && $(".filters__tags").hasClass("filters__tags--active")) || !filters_initial_load) {
      filters_initial_load = false;

      // Start filtering
      $(".loadmore-container").addClass("filtering");

      // Trigger ajax
      var data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filter_data
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        beforeSend: function (xhr) {},
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // insert the posts to the container
          $(".loadmore-container").html(data.content);

          // Re-init links to make sure linklines on newly loaded content still work
          linksInit();

          // Re-init lazy load
          lazyLoadInstance.update(); // reinit lazy load after clones

          // Re-init effects
          effectsInit();

          // hide load more button, if there are not enough posts for the second page
          if (data.max_page < 2) {
            $(".paging__loadmore").hide();
          } else {
            $(".paging__loadmore").show();
          }

          // Finish filtering
          $(".loadmore-container").removeClass("filtering");
        },
        error: function (data) {}
      });
    }
  }
}

// Setup an trigger filtering
let filters_initial_load = true;

if ($(".filters").length) {
  // Filter on page load
  filters__filter_posts();

  // Filter on submit
  $(".filters").submit(function (e) {
    e.preventDefault();
    filters__filter_posts();
    // do not submit the form
    return false;
  });

  // Submit for on checkbox click
  $(".filters").on("change", "input:checkbox", function () {
    $(".filters input").not(this).prop("checked", false);
    // Update filtering
    $(".filters").submit();
  });

  // Clear all
  $(".filters__clearall").click(function () {
    // Remove all tags
    $(".filters__tags").removeClass("filters__tags--active");
    $(this).addClass("filters__clearall--active");
    // Uncheck all inputs
    $(".filters input").prop("checked", false);
    // Trigger filter
    filters__filter_posts();
  });
}

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects = false) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      // This is the offset for the intro module to minimise the amount of scroll
      //  before the animation starts after the homepage video
      offset: val.id === "intro" ? "55%" : "85%"
    });
  });
}; // effectsInit();

// Refresh effects animation on load
setTimeout(function () {
  effectsInit(effects);
}, 200);

/*  ==========================================================================
    Internal links smooth scroll
    ========================================================================== */

const internalLinks = document.querySelectorAll("a[href^='#']");

const internalLinksInit = function (links = null) {
  if (!links) {
    return;
  }

  links.forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        e.preventDefault(); // Prevent default anchor link behavior

        const siteHeader = document.querySelector(".siteheader");
        const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
        const offset = headerHeight + 80; // Header height + extra padding

        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  });
};

internalLinksInit(internalLinks);

/*  ==========================================================================
    Pageheader home video load opacity
    ========================================================================== */

const pageheaderHome = document.querySelector(".pageheader--home");
const pageheaderHomeBg = document.querySelector(".pageheader--home .pageheader__bg");
const pageheaderHomeVideoiframe = document.querySelector(
  ".pageheader--home .pageheader__bg .pageheadervideo .pageheadervideo__iframe--vimeo"
);

let headerSkipped = false;

// Configuration
const SETTINGS = {
  startHeight: 100, // Initial height in vh
  endHeight: 50, // Final height in vh (where it stops shrinking)
  scrollRange: 800 // Pixels of scroll until it is fully shrunk & invisible
};

const applyHeaderProgress = progress => {
  progress = Math.min(Math.max(progress, 0), 1);

  const currentHeight = SETTINGS.startHeight - progress * (SETTINGS.startHeight - SETTINGS.endHeight);

  const currentOpacity = 1 - progress;

  pageheaderHome.style.height = `${currentHeight}vh`;
  pageheaderHome.style.opacity = currentOpacity.toFixed(2);

  if (progress >= 1) {
    pageheaderHome.style.pointerEvents = "none";
    pageheaderHome.style.visibility = "hidden";
  } else {
    pageheaderHome.style.pointerEvents = "auto";
    pageheaderHome.style.visibility = "visible";
  }
};

const pageheaderHomeBgInit = function (bg = false) {
  if (!bg || !pageheaderHome) {
    return;
  }

  const updateHeader = () => {
    if (headerSkipped) {
      return;
    }

    const scrollY = window.scrollY;
    const progress = Math.min(scrollY / SETTINGS.scrollRange, 1);

    applyHeaderProgress(progress);
  };

  // Vimeo Logic
  if (pageheaderHomeVideoiframe) {
    const player = new Vimeo.Player(pageheaderHomeVideoiframe);
    player.on("play", () => {
      const scrollY = window.scrollY;
      // Calculate progress (0 at top, 1 at the end of scrollRange)
      const progress = Math.min(scrollY / SETTINGS.scrollRange, 1);

      updateHeader();
      // Remove any CSS "effect" classes that might override our JS
      pageheaderHome.classList.forEach(cls => {
        if (cls.includes("effect")) {
          pageheaderHome.classList.remove(cls);
        }
      });
    });
  }

  // Smooth scroll listener
  window.addEventListener(
    "scroll",
    () => {
      window.requestAnimationFrame(updateHeader);

      setTimeout(function () {
        Waypoint.refreshAll();
      }, 250);
    },
    { passive: true }
  );

  // Initial run to set state on page load
  updateHeader();
};

pageheaderHomeBgInit(pageheaderHomeBg);

/*  ==========================================================================
    pageheader__scroll add href as id to first module below pageheader
    ========================================================================== */

const pageheaderScrollLink = document.querySelector(".pageheader--home .pageheader__body .pageheader__scroll");

const pageheaderScrollLinkInit = function (link = null) {
  if (!link) {
    return;
  }
  link.addEventListener("click", function (e) {
    e.preventDefault(); // Prevent default anchor link behavior

    headerSkipped = true;

    // Instantly jump animation to end state
    applyHeaderProgress(1);

    // Optional: stop listening to scroll entirely
    // window.removeEventListener("scroll", updateHeader);

    const siteHeader = document.querySelector(".siteheader");
    const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
    const offset = headerHeight; // Header height + extra padding

    // const firstModule = document.querySelector(".pageheader--home + .module");

    const targetElement = document.querySelector(".pageheader--hometextversion");

    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });

    headerSkipped = false;
  });
};

// Initialize the function
pageheaderScrollLinkInit(pageheaderScrollLink);

/*  ==========================================================================
    Module - Stacked Works tile__cursor effect
    ========================================================================== */
const tileCursors = document.querySelectorAll(".tile--work .tile__cursor");

const tileCursorsInit = function (cursors = null) {
  if (!cursors || cursors.length === 0) {
    return;
  }

  cursors.forEach(cursor => {
    let parent = cursor.closest(".tile--work");

    if (!parent) {
      return;
    }

    let cursorPos = { x: sessionCursorPos.x, y: sessionCursorPos.y }; // Store the last mouse position
    let moveCursor = true;

    const updateCursor = () => {
      // If no mousemove event triggered, use sessionCursorPos
      if (!cursorPos.x || !cursorPos.y) {
        cursorPos.x = sessionCursorPos.x;
        cursorPos.y = sessionCursorPos.y;
      }

      const parentRect = parent.getBoundingClientRect();

      // Offset by half width & height to center it on the cursor
      const cursorWidth = cursor.offsetWidth / 2;
      const cursorHeight = cursor.offsetHeight / 2;

      // Adjust position relative to parent
      const posX = cursorPos.x - parentRect.left - cursorWidth;
      const posY = cursorPos.y - parentRect.top - cursorHeight;

      cursor.style.left = `${posX}px`;
      cursor.style.top = `${posY}px`;
    };

    // Update stored mouse position on movement
    parent.addEventListener("mousemove", e => {
      if (!moveCursor) {
        return;
      }

      cursorPos.x = e.clientX;
      cursorPos.y = e.clientY;

      updateCursor();

      moveCursor = false;
      setTimeout(() => (moveCursor = true), 10); // Reduced delay for smooth movement
    });

    window.addEventListener("load", updateCursor);

    // Ensure cursor stays in place when scrolling
    window.addEventListener("scroll", updateCursor, { passive: true });
  });
};

// tileCursorsInit(tileCursors);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const parent = elem.closest(".module--featured--carousel, .testimonials-carousel");
    const navigation = parent.querySelector(".featured__header .owl-nav, .testimonials-carousel__nav .owl-nav");
    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fal fa-arrow-left'></i>", "<i class='fal fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      navContainer: navigation
    });

    // cursorsInit();
    Waypoint.refreshAll();

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const imagerowCarousels = document.querySelectorAll(".imagerow--carousel .owl-carousel");

const imagerowCarouselInit = function (imagerowCarousels) {
  if (imagerowCarousels.length <= 0) {
    return;
  }

  imagerowCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });

    // cursorsInit();

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // imagerowCarouselInit();
imagerowCarouselInit(imagerowCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
    Testimonials Carousel - return current active slide index
    ========================================================================== */

const testimonialsCarouselInit = function () {
  const testimonialsCarouselContent = document.querySelectorAll(".testimonials-carousel__content");

  if (testimonialsCarouselContent.length <= 0) {
    return;
  }

  testimonialsCarouselContent.forEach(content => {
    const carousel = content.querySelector(".row .col .row--carousel .owl-carousel");
    const counter = content.querySelector(
      ".row .col .testimonials-carousel__nav .testimonials-carousel__nav-counter .testimonials-carousel__nav-counter-current"
    );

    if (!carousel) {
      return;
    }

    // Find first active slide
    const allSlides = carousel.querySelectorAll(".owl-item");
    let activeIndex = Array.from(allSlides).findIndex(slide => slide.classList.contains("active"));

    activeIndex = activeIndex + 1;
    counter.textContent = String(activeIndex).padStart(2, "0");

    // Attach event listener only once
    $(carousel)
      .off("translated.owl.carousel")
      .on("translated.owl.carousel", function () {
        testimonialsCarouselInit();
      });
  });
};

// Initialize the function
testimonialsCarouselInit();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavClose = document.querySelector(".mobnav-close");
const mobnavOpenclass = "mobnavopen";

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    // IT'S NOT OPEN...
    if (body.classList.contains(mobnavOpenclass)) {
      body.classList.remove(mobnavOpenclass);
    } else {
      body.classList.add(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
  NAVIGATION - Desktops attrs for dropdowns
  ========================================================================== */

const sitenavItemsHasDropdown = document.querySelectorAll(".sitenav__item--hasdropdown");

const sitenavItemsHasDropdownInit = function () {
  if (!sitenavItemsHasDropdown.length) {
    return;
  }

  sitenavItemsHasDropdown.forEach(function (sitenavItemHasDropdown) {
    const sitenavLink = sitenavItemHasDropdown.querySelector(".sitenav__link");

    sitenavLink.setAttribute("aria-haspopup", "true");
    sitenavLink.setAttribute("aria-expanded", "false");

    sitenavItemHasDropdown.addEventListener("mouseenter", function () {
      sitenavLink.setAttribute("aria-expanded", "true");
    });

    sitenavItemHasDropdown.addEventListener("mouseleave", function () {
      sitenavLink.setAttribute("aria-expanded", "false");
    });
  });
}; // sitenavItemsHasDropdownInit()
sitenavItemsHasDropdownInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__link");

const mobnavlinksInit = function () {
  if (!mobnavLinks.length) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      const mobnavTargetSection = e.target.closest(".sitenav__item");

      if (!mobnavTargetSection.classList.contains("sitenav__item--open")) {
        e.preventDefault(); // Prevent navigation on first tap
        mobnavTargetSection.classList.add("sitenav__item--open");
        mobnavLink.setAttribute("aria-expanded", "true");
      } else {
        mobnavTargetSection.classList.remove("sitenav__item--open"); // Allow navigation on second tap
        mobnavLink.setAttribute("aria-expanded", "false");
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener("click", function (e) {
    mobnavLinks.forEach(function (mobnavLink) {
      const mobnavTargetSection = mobnavLink.closest(".sitenav__item");

      if (!mobnavTargetSection.contains(e.target)) {
        mobnavTargetSection.classList.remove("sitenav__item--open");
      }
    });
  });
}; // mobnavlinksInit();

mobnavlinksInit();

/*  ==========================================================================
  NAVIGATION - siteheader--transparent class when 
               siteheader over pageheader--home
  ========================================================================== */

const siteHeader = document.querySelector(".siteheader");

const siteHeaderInit = function (siteHeader = false, pageheaderHome = false) {
  if (!siteHeader || !pageheaderHome) {
    return;
  }

  const updateHeaderTransparency = () => {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;

    // Determine the threshold (50vh)
    const threshold = viewportHeight * 0.5;

    // Toggle transparency class
    // It will now start removing 'transparent' as soon as you pass 50% of the screen
    if (scrollY < threshold) {
      siteHeader.classList.add("siteheader--transparent");
    } else {
      siteHeader.classList.remove("siteheader--transparent");
    }
  };

  // Run once on load and on scroll
  updateHeaderTransparency();
  window.addEventListener("scroll", updateHeaderTransparency, { passive: true });
};

// Initialize the function
siteHeaderInit(siteHeader, pageheaderHome);

/*  ==========================================================================
  Polyfill IE11 for forEach
  ========================================================================== */

  if ("NodeList" in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }
